// World geometry shared between the 3D scene and the HUD minimap.
export const WORLD = {
  xMin: -200,
  xMax: 200,
  zMin: -130,
  zMax: 130,
  riverHalfWidth: 13,
  bankInner: 16, // where a bank starts from the river center
  bankOuter: 118, // outer edge of a bank
};

// Left bank (Progressive) sits at negative Z, Right bank (Traditional) at positive Z.
export const BANK = {
  progressive: { z: -60, sign: -1, color: '#2fe6a8' },
  traditional: { z: 60, sign: 1, color: '#c9a24a' },
};

// Ten ideological zones spread along the river (X axis).
const RAW = [
  { id: 'healthcare', title: 'Healthcare', icon: 'HeartPulse', accent: '#ff6b6b' },
  { id: 'economy', title: 'Economy', icon: 'TrendingUp', accent: '#f5c542' },
  { id: 'media-books', title: 'Media & Books', icon: 'Newspaper', accent: '#7dd3fc' },
  { id: 'culture-fashion', title: 'Culture & Fashion', icon: 'Shirt', accent: '#f0abfc' },
  { id: 'policy-law', title: 'Policy & Law', icon: 'Scale', accent: '#d4af37' },
  { id: 'religion', title: 'Religion', icon: 'Church', accent: '#fcd34d' },
  { id: 'gender-norms', title: 'Gender & Social Norms', icon: 'Users', accent: '#a78bfa' },
  { id: 'technology', title: 'Technology', icon: 'Cpu', accent: '#22d3ee' },
  { id: 'education-sports', title: 'Education & Sports', icon: 'GraduationCap', accent: '#4ade80' },
  { id: 'environment-travel', title: 'Environment & Travel', icon: 'Leaf', accent: '#34d399' },
];

const N = RAW.length;
const SPAN = 360; // total spread along X
export const ZONES = RAW.map((z, i) => ({
  ...z,
  index: i,
  number: i + 1,
  x: -SPAN / 2 + (i * SPAN) / (N - 1),
}));

export const zoneById = (id) => ZONES.find((z) => z.id === id);
